/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.standards.courses'},
});

const CoursesItem = () => (
  <RouteLinkItem
    route="midas/settings/standards/courses"
    title={messages.title}
  />
);

export default CoursesItem;
